const initCollectionPickerSwiper = (root) => {
  if (typeof window.Swiper !== 'function') return;
  if (!root) return;

  const swiperEl = root.querySelector('.collection-picker__swiper');
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

  const wrap = swiperEl.closest('.collection-picker__swiper-wrap');
  if (!wrap) return;

  const prevEl = wrap.querySelector('.collection-picker__arrow--prev');
  const nextEl = wrap.querySelector('.collection-picker__arrow--next');
  const paginationEl = wrap.querySelector('.collection-picker__pagination');

  const instance = new Swiper(swiperEl, {
    slidesPerView: 2.2,
    slidesPerGroup: 1,
    spaceBetween: 20,
    centeredSlides: false,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    navigation:
      prevEl && nextEl
        ? {
            nextEl,
            prevEl
          }
        : false,
    pagination:
      paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
    on: {
      init() {
        swiperEl.classList.add('swiper-initialized');
      }
    }
  });

  // Store instance if needed later
  swiperEl._collectionPickerSwiper = instance;
};

// Initial load: init every Custom collection picker section on the page.
document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.collection-picker[data-section-id]');
  roots.forEach((root) => initCollectionPickerSwiper(root));
});

// Theme editor / dynamic reloads: initialize for the specific section that was loaded.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches('.collection-picker[data-section-id]')) {
    initCollectionPickerSwiper(event.target);
  }
});

